import React from "react";
import { Skeleton } from "app/components/Skeleton";

export const ActivityItemSkeleton: React.FC = () => (
  <div className="flex w-full flex-col gap-1 rounded-md border border-gray-100 px-3.5 py-3">
    <div className="flex items-center gap-2">
      <Skeleton className="!size-5 !min-w-5 !min-h-5 rounded-full" />
      <Skeleton className="h-3 w-24 rounded" />
    </div>
    <div className="flex w-full items-center justify-between gap-2">
      <div className="flex-1">
        <Skeleton className="h-4 w-32 rounded mb-1" />
        <Skeleton className="h-3 w-full rounded" />
      </div>
      <Skeleton className="h-3 w-16 rounded shrink-0" />
    </div>
  </div>
);

export const ActivityGroupSkeleton: React.FC = () => (
  <div className="flex flex-col gap-4">
    <Skeleton className="h-4 w-20 rounded" />
    <div className="flex flex-col gap-4">
      {[...Array(3)].map((_, i) => (
        <ActivityItemSkeleton key={i} />
      ))}
    </div>
  </div>
);
